import React, { useState } from 'react';
import { TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

/**
 * Composant TextField pour les mots de passe avec bouton œil pour afficher/masquer
 * Étend TextField de Material-UI avec gestion automatique du type password/text
 */
type PasswordTextFieldProps = Omit<TextFieldProps, 'type'> & {
  // Permet de forcer le type si besoin, mais par défaut c'est password
  initialShowPassword?: boolean;
};

const PasswordTextField: React.FC<PasswordTextFieldProps> = ({
  initialShowPassword = false,
  InputProps,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(initialShowPassword);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <TextField
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              tabIndex={-1}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordTextField;
